import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './styles/App.css';
import Header from './components/Header';
import Home from './pages/Home';
import Dashboard from './components/Dashboard';
import KanbanBoard from './components/KanbanBoard';
import DashboardFinanceiro from './components/DashboardFinanceiro/DashboardFinanceiro';
import Repositorio from './components/Repositorio/Repositorio';
import Metas from './pages/Metas';
import Relatorios from './pages/Relatorios';
import GestaoFiscal from './pages/GestaoFiscal';
import Marketplace from './pages/Marketplace';
import AgendarMensagemModal from './components/AgendarMensagemModal';
import { oportunidadesAPI, gestaoClickAPI, mensagensAgendadasAPI } from './services/api';

function App() {
  const getMesAtual = () => { const h=new Date(); return h.getFullYear()+'-'+String(h.getMonth()+1).padStart(2,'0'); };

  const [oportunidades, setOportunidades] = useState([]);
  const [resumo, setResumo] = useState([]);
  const [resumoFinanceiro, setResumoFinanceiro] = useState(null);
  const [loading, setLoading] = useState(true);
  const [sincronizando, setSincronizando] = useState(false);
  const [notificacao, setNotificacao] = useState({ show: false, message: '', type: 'success' });
  const [modalMensagemAberto, setModalMensagemAberto] = useState(false);
  const [filtros, setFiltros] = useState({ search: '', tecnico_nome: '', tipo_servico: '', mes_ano: getMesAtual() });

  useEffect(() => { const s=localStorage.getItem('prospera_theme'); if(s) document.documentElement.setAttribute('data-theme',s); }, []);

  const mostrarNotificacao = (message, type='success', duration=5000) => {
    setNotificacao({ show:true, message, type });
    setTimeout(() => setNotificacao({ show:false, message:'', type:'success' }), duration);
  };

  useEffect(() => { const init=async()=>{ await carregarDados(); await verificarOSPendentes(); }; init(); }, []);

  const carregarDados = async () => {
    try {
      setLoading(true);
      const rp = filtros.mes_ano ? { mes_ano: filtros.mes_ano } : {};
      const [o,r,f] = await Promise.all([oportunidadesAPI.listar(filtros), oportunidadesAPI.resumoPorStatus(rp), oportunidadesAPI.resumoFinanceiro(rp)]);
      setOportunidades(o.data.data||[]); setResumo(r.data.data||[]); setResumoFinanceiro(f.data.data||null);
    } catch(e) { console.error('Erro ao carregar:',e); } finally { setLoading(false); }
  };

  const handleSincronizar = async () => {
    try { setSincronizando(true); await gestaoClickAPI.sincronizar(); await verificarOSPendentes(); await carregarDados(); mostrarNotificacao('✓ Sincronização concluída!','success'); }
    catch(e) { console.error(e); mostrarNotificacao('Erro na sincronização.','error'); }
    finally { setSincronizando(false); }
  };

  const verificarOSPendentes = async () => {
    try { const r=await fetch('/api/oportunidades/verificar-pendentes'); if(!r.ok) return; const d=await r.json(); if(d.success&&d.data.total>0) await moverOSPendentes(d.data.total); }
    catch(e) { console.error(e); }
  };

  const moverOSPendentes = async (total) => {
    try { setSincronizando(true); const r=await fetch('/api/oportunidades/mover-pendentes',{method:'POST'}); if(!r.ok) throw new Error('HTTP '+r.status); const d=await r.json(); if(d.success){await gestaoClickAPI.sincronizar();await carregarDados();mostrarNotificacao('✅ '+total+' OS migradas.','success',7000);} }
    catch(e) { console.error(e); } finally { setSincronizando(false); }
  };

  const handleAtualizarStatus = async (id,novoStatus) => {
    try { await oportunidadesAPI.atualizarStatus(id,novoStatus); await carregarDados(); }
    catch(e) { console.error(e); mostrarNotificacao('Erro ao atualizar status.','error'); }
  };

  const handleFiltrar = (f) => { setFiltros(f); };

  const handleAgendarMensagem = async (dados) => {
    try { const r=await mensagensAgendadasAPI.criar(dados); if(r.data.success){mostrarNotificacao('✅ Mensagem agendada!','success');setModalMensagemAberto(false);} }
    catch(e) { console.error(e); mostrarNotificacao('❌ Erro ao agendar','error'); }
  };

  useEffect(() => { carregarDados(); }, [filtros]);

  // Sync automática só quando idle (5min sem atividade)
  useEffect(() => {
    let timer;
    const reset=()=>{ clearTimeout(timer); timer=setTimeout(()=>{console.log('🔄 Auto-sync (idle)');handleSincronizar();},300000); };
    const evts=['mousedown','mousemove','keypress','scroll','touchstart','click'];
    evts.forEach(e=>document.addEventListener(e,reset,true));
    reset();
    return()=>{clearTimeout(timer);evts.forEach(e=>document.removeEventListener(e,reset,true));};
  }, []);

  if (loading) return (<div className="pp-loading"><div className="pp-spinner"></div><p>Carregando Prospera+...</p></div>);

  return (
    <Router>
      <div className="App">
        {notificacao.show && <div className={'pp-notificacao pp-notif-'+notificacao.type}>{notificacao.message}</div>}
        <Header onSincronizar={handleSincronizar} sincronizando={sincronizando} onAgendarMensagem={()=>setModalMensagemAberto(true)} />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/servicos" element={<><Dashboard resumo={resumo} resumoFinanceiro={resumoFinanceiro} /><KanbanBoard oportunidades={oportunidades} onAtualizarStatus={handleAtualizarStatus} onRecarregar={carregarDados} filtros={filtros} onFiltrar={handleFiltrar} /></>} />
          <Route path="/financeiro" element={<DashboardFinanceiro />} />
          <Route path="/metas" element={<Metas />} />
          <Route path="/relatorios" element={<Relatorios />} />
          <Route path="/fiscal" element={<GestaoFiscal />} />
          <Route path="/marketplace" element={<Marketplace />} />
          <Route path="/repositorio" element={<Repositorio />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <AgendarMensagemModal isOpen={modalMensagemAberto} onClose={()=>setModalMensagemAberto(false)} onConfirmar={handleAgendarMensagem} />
      </div>
    </Router>
  );
}
export default App;
